import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';
import { VpnKey as VpnKeyIcon } from '@mui/icons-material';
import { AdminOrg } from 'new/stores/adminOrgs/adminOrgs.types';

interface SsoIdpTabProps {
  org: AdminOrg;
}

/**
 * SSO/IDP config (`ApiAuthConfig`) is a top-level resource scoped to the caller's own
 * active org, with no org_id filter for cross-org admin listing — and switching the
 * session into the customer org to list it would strip super_user status. Until the
 * backend adds an org_id-filterable index (or a nested /orgs/{id}/api_auth_configs
 * route), this tab can't show live data. Placeholder only, layout ready to wire up.
 */
export function SsoIdpTab({ org }: SsoIdpTabProps) {
  return (
    <Stack spacing={2} alignItems="center" sx={{ py: 6, textAlign: 'center' }}>
      <VpnKeyIcon fontSize="large" color="disabled" />
      <Typography variant="subtitle1">SSO / IDP data unavailable</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        Nexla admins can't currently list {org.name}'s SSO/IDP configuration from a cross-org admin
        context — this requires a backend change (an org-scoped index for api_auth_configs). This
        tab will show live SAML/OIDC status once that support ships.
      </Typography>
      <Alert severity="info" sx={{ maxWidth: 420 }}>
        Pending backend support
      </Alert>
    </Stack>
  );
}
